export const GET_USER_SEGMENT_DETAILS = "/segment/details";
export const GET_CREATE_USER_SEGMENT = "/segment/create";
export const GET_USER_SEGMENT_EDIT = "/segment/edit";
